import AccessToken from "./access-token";

export default AccessToken;